<template>
  <div
    class="modal fade colored-header colored-header-primary"
    id="mod-add-manual"
    role="dialog"
    abindex="-1"
  >
    <div
      class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      role="document"
    >
      <div
        class="modal-content rounded-none bg-[#f8f8f8] p-[40px] md:min-h-screen"
      >
        <div
          class="modal-header modal-header-colored flex items-start justify-between p-0 m-0"
        >
          <h4
            class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
          >
            Create New Business User
          </h4>
          <button
            class="text-2xl text-[#353535]"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
            @click="reset"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="modal-body p-0 m-0">
          <div>
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Username</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.user.username.$error }]"
                type="text"
                placeholder="Username"
                autocomplete="off"
                v-model.trim="$v.user.username.$model"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
              <div class="invalid-feedback" v-if="!$v.user.username.required">
                Field is required.
              </div>
              <div
                class="invalid-feedback"
                v-if="!$v.user.username.alphaNumAndDotValidator"
              >
                Username must not include space or special characters!
              </div>
            </div>
          </div>
          <div class="py-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Password</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.user.password.$error }]"
                type="password"
                placeholder="Password"
                autocomplete="off"
                v-model.trim="$v.user.password.$model"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
              <div class="invalid-feedback" v-if="!$v.user.password.required">
                Field is required.
              </div>
              <div class="invalid-feedback" v-if="!$v.user.password.minLength">
                Password must have at least
                {{ $v.user.password.$params.minLength.min }} letters.
              </div>
            </div>
          </div>
          <div>
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Email address</label
            >
            <div class="pb-[16px]">
              <input
                :class="[{ 'is-invalid': $v.user.emailAddress.$error }]"
                type="email"
                placeholder="Email address of user"
                autocomplete="off"
                v-model.trim="$v.user.emailAddress.$model"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.user.emailAddress.required"
              >
                Field is required.
              </div>
              <div class="invalid-feedback" v-if="!$v.user.emailAddress.email">
                Email is invalid.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Phone Number</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.user.phoneNumber.$error }]"
                type="text"
                placeholder="Phone number of user"
                autocomplete="off"
                v-model.trim="$v.user.phoneNumber.$model"
                @blur="confirmPhoneNumberUnique"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
              <div
                class="text-danger"
                v-if="phoneNumberUnique === false"
                style="font-size:10px"
              >
                The phone number provided has been used.
              </div>
              <div
                class="invalid-feedback"
                v-if="!$v.user.phoneNumber.required"
              >
                Field is required.
              </div>
              <div
                class="invalid-feedback"
                v-if="!$v.user.phoneNumber.validatePhone"
              >
                Number not valid!
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Name</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.user.name.$error }]"
                type="text"
                placeholder="Name of user"
                v-model.trim="$v.user.name.$model"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
              <div class="invalid-feedback" v-if="!$v.user.name.required">
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Role</label
            >

            <div>
              <select
                :class="[{ 'is-invalid': $v.user.role.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.user.role.$model"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              >
                <option v-for="r in roles" :key="r.id" :value="r.id">
                  {{ r.text }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="!$v.user.role.required">
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Staff Id</label
            >
            <div>
              <input
                type="text"
                placeholder="Staff Id of user"
                v-model.trim="user.staffId"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
            </div>
          </div>
          <div v-if="isSales" class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Sales Access Id</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.user.salesAccessId.$error }]"
                type="text"
                placeholder="Sales Access Id of user"
                v-model.trim="$v.user.salesAccessId.$model"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />

              <div
                class="invalid-feedback"
                v-if="!$v.user.salesAccessId.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div v-if="currentUser.type != 'Manufacturer'" class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Branch</label
            >
            <div class="py=[16px]">
              <select
                :class="[{ 'is-invalid': $v.user.branch.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.user.branch.$model"
                class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              >
                <option v-for="br in branches" :key="br.id" :value="br.id">
                  {{ br.name }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="!$v.user.branch.required">
                Field is required.
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px]">
            <button
              class="bg-[#fff] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full disabled:cursor-not-allowed"
              type="button"
              data-dismiss="modal"
              :disabled="isCreating"
              @click="reset"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full disabled:cursor-not-allowed"
              :disabled="isBusyModal || !phoneNumberUnique || isCreating"
              type="button"
              @click.prevent="createNewUser"
            >
              {{ isCreating ? "Loading..." : "Create User" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helper } from "@/helper";
import { mapActions, mapGetters } from "vuex";
import { required, minLength, helpers, email } from "vuelidate/lib/validators";
import { bus } from "../../main";

const alphaNumAndDotValidator = helpers.regex("alphaNumAndDot", /^[a-z\d.]*$/i);
const validatePhone = (value) => helper.validatePhone(value);

export default {
  name: "CreateUser",

  data() {
    return {
      isBusyModal: false,
      isCreating: false,
      branches: [],
      user: {
        username: "",
        password: "",
        phoneNumber: "",
        emailAddress: "",
        name: "",
        role: "",
        staffId: "",
        salesAccessId: "",
        branch: "",
      },
      phoneNumberUnique: null,
    };
  },

  validations() {
    const user = {
      username: { required, alphaNumAndDotValidator },
      password: { required, minLength: minLength(6) },
      emailAddress: { required, email },
      phoneNumber: { required, validatePhone },
      name: { required },
      role: { required },
    };

    if (this.currentUser.type != "Manufacturer") {
      if (this.isSales) {
        return {
          user: {
            ...user,
            branch: { required },
            salesAccessId: { required },
          },
        };
      } else {
        return {
          user: {
            ...user,
            branch: { required },
          },
        };
      }
    } else {
      if (this.isSales) {
        return {
          user: {
            ...user,
            salesAccessId: { required },
          },
        };
      } else {
        return {
          user: user,
        };
      }
    }
  },

  computed: {
    ...mapGetters(["roles"]),
    currentUser: function() {
      return this.$store.state.currentUser;
    },

    isSales: function() {
      const role = this.roles.find((x) => x.id === this.user.role);
      return role ? role.text === "Sales" : false;
    },
  },

  created() {
    this.getRoles();
    this.getBranches();
    bus.$on("getsales", this.refreshRoles);
    bus.$on("getsales", () => {
      // console.log("event received");
    });
  },

  methods: {
    ...mapActions(["getRoles"]),
    refreshRoles() {
      this.getRoles();
    },
    async confirmPhoneNumberUnique() {
      if (this.user.phoneNumber)
        await this.$http
          .get("/Users/isPhoneNumberUnique/" + `${this.user.phoneNumber}`)
          .then(function(res) {
            this.phoneNumberUnique = res.body;
          })
          .catch(function() {});
    },
    async createNewUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isCreating = true;
        let data = {
          username: this.user.username,
          password: this.user.password,
          phoneNumber: this.user.phoneNumber,
          emailAddress: this.user.emailAddress,
          type: this.currentUser.type,
          displayName: this.user.name,
          role: this.user.role,
          parentId: this.currentUser.parentId,
          deliveryAddress: "N/A",
          branchId: this.user.branch,
          staffId: this.user.staffId,
          salesAccessId: this.user.salesAccessId,
        };

        try {
          const response = await this.$http.post("/Users/create", data);
          if (response.ok) {
            this.reset();
            this.$toast.success("User created successfully.", {
              icon: true,
              rtl: false,
            });
            this.$emit("onCreateUserComplete");
          }
        } catch (error) {}

        this.isCreating = false;
        this.isBusyModal = false;
      }
    },

    async getBranches() {
      const response = await this.$http.get(
        "/Branches/getListNoPaging?active=" +
          true +
          "&parentId=" +
          this.currentUser.parentId
      );

      if (response.ok) this.branches = response.body;
    },

    reset() {
      this.user.username = this.user.password = this.user.phoneNumber = this.user.emailAddress = this.user.name = this.user.role = this.user.staffId = this.user.salesAccessId = this.user.branch =
        "";

      setTimeout(() => {
        this.$v.$reset();
      }, 0);
    },
  },
};
</script>
<style scoped>
input,
select {
  padding: 12px 14px !important;
  font-size: 14px !important;
  outline: none !important;
}
::placeholder {
  color: #96a0b5 !important;
  font-weight: 400 !important;
}
</style>
